var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mt-4" }, [
    _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-center" },
      [
        _c("div", [
          _c("h4", [
            _vm._v(
              "Users in " +
                _vm._s(_vm.supergroup.name) +
                " - " +
                _vm._s(_vm.userCount) +
                " users\n          "
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-sm",
                attrs: { "aria-label": "Close" },
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-times" })]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm.activePremiumToolkitCount > 0
              ? _c("span", [
                  _vm._v(
                    "\n          (" +
                      _vm._s(_vm.activePremiumToolkitCount) +
                      " Active Premium Toolkit)\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.activePremiumPathwaysCount > 0
              ? _c("span", [
                  _vm._v(
                    "\n          (" +
                      _vm._s(_vm.activePremiumPathwaysCount) +
                      " Active Premium Pathways)\n        "
                  )
                ])
              : _vm._e()
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "text-center" }, [
          _c("i", { staticClass: "fa fa-spinner fa-spin fa-2x" })
        ])
      : _vm.error
      ? _c("div", { staticClass: "alert alert-danger" }, [
          _vm._v("\n    " + _vm._s(_vm.error) + "\n  ")
        ])
      : _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filterText,
                expression: "filterText"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Filter by name or email..." },
            domProps: { value: _vm.filterText },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.filterText = $event.target.value
              }
            }
          })
        ]),
    _vm._v(" "),
    _vm.users.length === 0
      ? _c("div", { staticClass: "text-muted" }, [
          _vm._v("\n    No users found in this supergroup.\n  ")
        ])
      : _vm.sortedUsers.length === 0
      ? _c("div", { staticClass: "text-muted" }, [
          _vm._v("\n    No users match your filter.\n  ")
        ])
      : _c("div", [
          _c("table", { staticClass: "table table-striped table-condensed" }, [
            _c("thead", [
              _c("tr", [
                _c(
                  "th",
                  {
                    staticClass: "sortable",
                    on: {
                      click: function($event) {
                        return _vm.sortBy("name")
                      }
                    }
                  },
                  [
                    _vm._v("\n              Name \n              "),
                    _vm.sortKey === "name"
                      ? _c("i", {
                          class: [
                            "fa",
                            _vm.sortAsc ? "fa-sort-asc" : "fa-sort-desc"
                          ]
                        })
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "sortable",
                    on: {
                      click: function($event) {
                        return _vm.sortBy("email")
                      }
                    }
                  },
                  [
                    _vm._v("\n              Email\n              "),
                    _vm.sortKey === "email"
                      ? _c("i", {
                          class: [
                            "fa",
                            _vm.sortAsc ? "fa-sort-asc" : "fa-sort-desc"
                          ]
                        })
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "sortable",
                    on: {
                      click: function($event) {
                        return _vm.sortBy("title")
                      }
                    }
                  },
                  [
                    _vm._v("\n              Title\n              "),
                    _vm.sortKey === "title"
                      ? _c("i", {
                          class: [
                            "fa",
                            _vm.sortAsc ? "fa-sort-asc" : "fa-sort-desc"
                          ]
                        })
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "sortable",
                    on: {
                      click: function($event) {
                        return _vm.sortBy("active_toolkit_license.end_date")
                      }
                    }
                  },
                  [
                    _vm._v("\n              Toolkit End Date\n              "),
                    _vm.sortKey === "active_toolkit_license.end_date"
                      ? _c("i", {
                          class: [
                            "fa",
                            _vm.sortAsc ? "fa-sort-asc" : "fa-sort-desc"
                          ]
                        })
                      : _vm._e()
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.sortedUsers, function(user) {
                return _c("tr", { key: user.uuid }, [
                  _c("td", [
                    _c(
                      "a",
                      { attrs: { href: "#!/user_info?uuid=" + user.uuid } },
                      [_vm._v(_vm._s(user.name))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(user.email))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(user.title))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.formatEndDate(
                          user.active_toolkit_license &&
                            user.active_toolkit_license.end_date
                        )
                      )
                    )
                  ])
                ])
              }),
              0
            )
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }